const StartPage = () => import(/* webpackChunkName: "StartPage" */ "./pages/StartPage");
const StartOverview = () => import(/* webpackChunkName: "StartOverview" */ "./pages/StartPage/StartOverview");

const pages = [
    {
        path: "/",
        redirect: "/start-page",
    },
    {
        path: "/",
        name: "StartPage",
        component: StartPage,
        children: [
            {
                path: "/start-page",
                name: "StartOverview",
                component: StartOverview,
            },
        ],
    },
];
export { pages };
